{
    "formRows": [
      {
        "formGroups": [
          {
            "style": {
              "gridColumn": "span 3"
            },
            "control": {
              "label": "contactName",
              "displayLabel": "Contact Name",
              "placeHolder": "Enter Contact Name",
              "fieldInfo": {
                "dataType": "text"
              },
              "validators": [
                {
                  "type": "required",
                  "message": "Contact Name is required"
                }
              ]
            }
          },
          {
            "style": {
              "gridColumn": "span 3"
            },
            "control": {
              "label": "active",
              "displayLabel": "Active",
              "skipLabel": true,
              "defaultValue": true,
              "fieldInfo": {
                "dataType": "boolean"
              }
            }
          },
          {
            "style": {
              "gridColumn": "span 3"
            },
            "control": {
              "label": "defaultContact",
              "displayLabel": "Default",
              "skipLabel": true,
              "fieldInfo": {
                "dataType": "boolean"
              }
            }
          }
        ]
      },
      {
        "formGroups": [
          {
            "style": {
              "gridColumn": "span 3"
            },
            "control": {
              "label": "addressLine1",
              "displayLabel": "Address Line 1",
              "placeHolder": "Enter Address Line 1",
              "fieldInfo": {
                "dataType": "text"
              },
              "validators": [
                {
                  "type": "required",
                  "message": "Address Line 1 is required"
                },
                {
                  "type": "maxlength",
                  "message": "Address Line 1 must be less than 100 characters",
                  "params": 100
                }
              ]
            }
          },
          {
            "style": {
              "gridColumn": "span 3"
            },
            "control": {
              "label": "addressLine2",
              "displayLabel": "Address Line 2",
              "placeHolder": "Enter Address Line 2",
              "fieldInfo": {
                "dataType": "text"
              },
              "validators": [
                {
                  "type": "required",
                  "message": "Address Line 2 is required"
                },
                {
                    "type": "maxlength",
                    "message": "Address Line 2 must be less than 100 characters",
                    "params": 100
                }
              ]
            }
          },
          {
            "style": {
              "gridColumn": "span 3"
            },
            "control": {
              "label": "pinCode",
              "displayLabel": "Postal Code",
              "placeHolder": "Enter Postal Code",
              "fieldInfo": {
                "dataType": "text"
              },
              "validators": [
                {
                  "type": "required",
                  "message": "Postal Code is required"
                },
                {
                  "type": "pattern",
                  "message": "Postal Code is invalid",
                  "params": "^[0-9]{6}$"
                }
              ]
            }
          }
        ]
      },
      {
        "formGroups": [
          {
            "style": {
              "gridColumn": "span 3"
            },
            "control": {
              "label": "cityId",
              "displayLabel": "City",
              "placeHolder": "Enter City",
              "fieldInfo": {
                "dataType": "picklist",
                "lookupDetails": {
                  "apiUrl": "v1/cities/list",                  
                  "filterByKeys": ["NAME_CONTAINS"],
                  "limit": 10,
                  "orderBy": { "name": "asc" },
                  "bindLabel": "name",
                  "bindValue": "id",
                  "additionalFilters": [
                    {
                      "name": "IS_ACTIVE",
                      "alias": "active",
                      "operator": "EQ",
                      "value": ["true"]
                    }
                  ],
                  "displayColumns": [
                    { "key": "name", "header": "Name" },
                    { "key": "code", "header": "Code" }
                  ]
                }
              }
            },
            "validators": [
              {
                "type": "required",
                "message": "City is required"
              }
            ]
          },
          {
            "style": { "gridColumn": "span 3" },
            "control": {
              "label": "stateId",
              "displayLabel": "State",
              "placeHolder": "Enter State",
              "fieldInfo": {
                "dataType": "picklist",
                "lookupDetails": {
                  "apiUrl": "v1/states/list",
                  "filterByKeys": ["NAME_CONTAINS"],
                  "limit": 10,
                  "bindLabel": "name",
                  "bindValue": "id",
                  "additionalFilters": [
                    {
                      "name": "ACTIVE_EQUALS",
                      "alias": "active",
                      "operator": "EQ",
                      "value": ["true"]
                    }
                  ],
                  "displayColumns": [
                    { "key": "name", "header": "Name" }
                  ]
                }
              }
            }
          },
          {
            "style": { "gridColumn": "span 3" },
            "control": {
              "label": "country",
              "displayLabel": "Country",
              "placeHolder": "Enter Country",
              "fieldInfo": {
                "dataType": "picklist",
                "lookupDetails": {
                  "apiUrl": "v1/countries/list",
                  "filterByKeys": ["NAME_CONTAINS"],
                  "limit": 10,
                  "bindLabel": "name",
                  "bindValue": "id",
                  "additionalFilters": [
                    {
                      "name": "ACTIVE_EQUALS",
                      "alias": "active",
                      "operator": "EQ",
                      "value": ["true"]
                    }
                  ],
                  "displayColumns": [
                    { "key": "name", "header": "Name" }
                  ]
                }
              }
            }
          }
        ]
      },
      {
        "formGroups": [
            {
                "style": {
                    "gridColumn": "span 3"
                },
                "control": {
                    "label": "email",
                    "displayLabel": "Email",
                    "placeHolder": "Enter Email",
                    "fieldInfo": {
                    "dataType": "text"
                    }
                },
                "validators": [
                    {
                        "type": "required",
                        "message": "Email is required"
                    }
                ]
            },
            {
                "style": {
                    "gridColumn": "span 3"
                },
                "control": {
                    "label": "directLine",
                    "displayLabel": "Direct Line",
                    "placeHolder": "Enter Direct Line",
                    "fieldInfo": {
                    "dataType": "number"
                    }
                }
            },
            {
                "style": {
                    "gridColumn": "span 3"
                },
                "control": {
                    "label": "boardLine",
                    "displayLabel": "Board Line",
                    "placeHolder": "Enter Board Line",
                    "fieldInfo": {
                    "dataType": "number"
                    }
                }
            }
        ]
      },
      {
        "formGroups": [
          {
            "style": { "gridColumn": "span 3" },
            "control": {
              "label": "communicationPreference",
              "displayLabel": "Communication Preference",
              "placeHolder": "Select Communication Preference",
              "fieldInfo": {
                "dataType": "select",
                "options": [
                  {
                    "label": "Email",
                    "value": "EMAIL"
                  },
                  {
                    "label": "Mobile",
                    "value": "MOBILE"
                  }
                ]
              }
            }
          },
          {
            "style": { "gridColumn": "span 3" },
            "control": {
              "label": "gstNumber",
              "displayLabel": "GST Number",
              "placeHolder": "Enter GST Number",
              "fieldInfo": {
                "dataType": "text"
              },
              "validators": [
                {
                  "type": "required",
                  "message": "GST Number is required"
                }
              ]
            }
          },
          {
            "style": { "gridColumn": "span 3" },
            "control": {
              "label": "gstType",
              "displayLabel": "GST Type",
              "placeHolder": "Select GST Type",
              "fieldInfo": {
                "dataType": "select",
                "options": [
                  {
                    "label": "Regular",
                    "value": "REGULAR"
                  },
                  {
                    "label": "ISD",
                    "value": "ISD"
                  }
                ]
              }
            }
          }
        ]
      },
      {
        "formGroups": [
          {
            "style": { "gridColumn": "span 3" },
            "control": {
              "label": "sez",
              "displayLabel": "SEZ",
              "skipLabel": true,
              "fieldInfo": {
                "dataType": "boolean"
              }
            }
          },
          {
            "style": { "gridColumn": "span 3" },
            "control": {
              "label": "sezCertificateNo",
              "displayLabel": "SEZ Certificate Number",
              "placeHolder": "Enter SEZ Certificate Number",
              "fieldInfo": {
                "dataType": "text"
              },
              "conditions": {
                "disabled": {
                  "rules": [
                    { "field": "sez", "operator": "EQUALS", "value": false }
                  ]
                }
              },
              "validators": [
                {
                  "type": "required",
                  "message": "SEZ Certificate Number is required"
                }
              ]
            }
          },
          {
            "style": { "gridColumn": "span 3" },
            "control": {
              "label": "sezValidityDate",
              "displayLabel": "SEZ Validity Date",
              "placeHolder": "Enter SEZ Validity Date",
              "fieldInfo": {
                "dataType": "date"
              },
              "conditions": {
                "disabled": {
                    "logic": "AND",
                    "rules": [
                     { "field": "sez", "operator": "EQUALS", "value": false }
                    ]
                }   
              },
              "validators": [
                {
                  "type": "required",
                  "message": "SEZ Validity Date is required"
                }
              ]
            }
          }
        ]
      }
    ]
}